// Scroll-reveal animation using IntersectionObserver
// Adds .n-revealed class to .n-reveal elements when they enter the viewport

export default function scrollReveal() {
    const elements = document.querySelectorAll('.n-reveal');

    if (!elements.length) return;

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('n-revealed');
                    observer.unobserve(entry.target);
                }
            });
        },
        {
            threshold: 0.1,
            rootMargin: '50px',
        }
    );

    elements.forEach((el) => observer.observe(el));
}
